<template>
  <div class="p-fluid formgrid grid mb-1 border-bottom-1 surface-border pb-2">
    <div class="field col-8 m-0">
      <label class="block text-lg font-semibold text-500 mb-1">Cliente</label>
      <div class="p-inputgroup">
        <AutoComplete 
          :modelValue="cliente" 
          :suggestions="suggestions" 
          field="nombre"
          @complete="$emit('buscarCliente', $event)"
          @update:modelValue="$emit('update:cliente', $event)"
          @item-select="alSeleccionarCliente($event.value)"
          placeholder="Buscar por Nombre" 
          class="p-inputtext-sm"
          forceSelection
        >
          <template #item="slotProps">
            <div class="font-bold text-sm">
              {{ slotProps.item.nombre }} - {{ slotProps.item.nit }}
            </div>
          </template>
        </AutoComplete>
        <Button
          icon="pi pi-user-plus"
          class="p-button-primary p-button-sm"
          style="width: 2.5rem;"
          v-tooltip.top="'Nuevo Cliente'"
          @click="$emit('nuevoCliente')"
        />
      </div>
    </div>
    <div class="field col-4 m-0">
      <label class="block text-lg font-semibold text-500 mb-1">NIT/CI</label>
      <InputText 
        :modelValue="nit" 
        @input="$emit('update:nit', $event.target.value)"
        placeholder="0" 
        class="p-inputtext-sm" 
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZapiClientForm',
  props: {
    cliente: { type: [String, Object], default: null },
    nit: { type: String, default: '' },
    suggestions: { type: Array, default: () => [] }
  },
  emits: ['update:cliente', 'update:nit', 'buscarCliente', 'nuevoCliente'],
  methods: {
    alSeleccionarCliente(clienteValue) {
      if (clienteValue && clienteValue.nit) {
        this.$emit('update:nit', String(clienteValue.nit));
      } else {
        this.$emit('update:nit', '0');
      }
      this.$emit('clienteSeleccionado', clienteValue);
    }
  }
}
</script>